import { supabase } from '../lib/supabase';

const SESSION_KEY = 'site_session_id';
const LOCATION_KEY = 'site_location_cache';

function getSessionId(): string {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

function getDeviceType(): string {
  const ua = navigator.userAgent.toLowerCase();
  if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
  if (/mobile|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return 'mobile';
  return 'desktop';
}

async function getLocation(): Promise<{ country?: string; city?: string } | null> {
  try {
    const cached = localStorage.getItem(LOCATION_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.ts < 86400000) return parsed.data;
    }

    const res = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(3000) });
    if (!res.ok) return null;

    const json = await res.json();
    const data = { country: json.country_name, city: json.city };
    localStorage.setItem(LOCATION_KEY, JSON.stringify({ data, ts: Date.now() }));
    return data;
  } catch {
    return null;
  }
}

export async function trackPageView(url: string) {
  try {
    const location = await getLocation();
    await supabase.from('site_analytics').insert({
      session_id: getSessionId(),
      event_type: 'page_view',
      event_category: 'navigation',
      page_url: url,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      device_type: getDeviceType(),
      screen_resolution: `${screen.width}x${screen.height}`,
      country: location?.country || null,
      city: location?.city || null,
    });
  } catch {
    // silent
  }
}

export async function trackEvent(eventType: string, category: string, data?: Record<string, any>) {
  try {
    await supabase.from('site_analytics').insert({
      session_id: getSessionId(),
      event_type: eventType,
      event_category: category,
      event_data: data || {},
      page_url: window.location.href,
      user_agent: navigator.userAgent,
      device_type: getDeviceType(),
      screen_resolution: `${screen.width}x${screen.height}`,
    });
  } catch {
    // silent
  }
}

export function getAnalyticsSessionId(): string {
  return getSessionId();
}
